import React from "react";

import useIsMobile from "Utilities/Hooks/useIsMobile";

import SidebarLinkButton from "../GoToGivingTab/SidebarLinkButton";
import { useProfileSidebarContext } from "../ProfileSidebar/ProfileSidebar";

export default function FamilyTab({ ...rest }) {
  const { showHousehold, setShowHousehold } = useProfileSidebarContext();
  const onClick = () => {
    setShowHousehold((show) => !show);
  };
  const buttonCopy = "Family";

  const isMobile = useIsMobile(680);

  if (!isMobile) return null;

  return (
    <SidebarLinkButton
      onClick={onClick}
      isActive={showHousehold}
      icon={`users ${showHousehold ? "fas" : "far"}`}
      text={buttonCopy}
      {...rest}
    />
  );
}